import { AccountGoal } from '../../shared/models/models';
import { IntegrationType } from 'src/app/modules/shared/models/integration.models';

export interface GoalSettings extends AccountGoal {
  url: string;
  selector: string;
  order: number;
  isGoal: boolean;
  integrationId: IntegrationType;
  integrationFields: MaRule[];
  createdDate: string;
}

export interface UsedGoal
{
  id: number;
  campaignsIds: number[];
  audiencesIds: number[];
  orchestrationIds: number[];
  raceIds: number[];
  streamIds: number[];
  segmentIds: number[];
  contentPoolIds: number[];
  reportIds: number[];
  trackedPairIds: number[];
}

export interface MaRule {
  value: string;
  field: string;
  operator: MaRuleOperator;
}

export enum MaRuleOperator {
  Equals = 0,
  GreaterThan,
  LessThan,
  NotEmpty,
  NotIn,
  Contains,
}

export enum MaFieldType {
  Numeric,
  Array,
  Hidden
}

